/** 로그인 시 정산 서류 안내 모달을 다시 볼 수 있도록 플래그 초기화 */
export const MISSING_DOCS_MODAL_SEEN_KEY = 'missionfund.missingDocsModalSeenAfterLogin';

export function clearMissingSettlementDocsModalSeen(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(MISSING_DOCS_MODAL_SEEN_KEY);
  } catch {
    // ignore
  }
}
